<!--
   Created by qing on 2022/5/23 上午11:59
   Des:
-->
<!--
   Created by qing on 2022/5/23 上午11:09
   Des:
-->
<template>

  <van-popup
    class="show-location-popup"
    v-model="show"
    position="bottom"
    get-container="body"
    close-on-popstate
    @close="closePopup"
    :style="{ height: '90%' }">

    <div class="location-popup-container" v-if="show">
      <div class="map-container">
        <el-amap vid="amap" ref="amap" class="amap-demo">
        </el-amap>
      </div>
      <div class="location-addr">
        {{locationAddr}}
      </div>

      <div class="location-btn" @click="location">
        <i class="iconfont icon-iconfontoptionbutton"></i>
      </div>

      <div class="close-btn" @click="cancel">
        <i class="el-icon-error"></i>
      </div>
    </div>
  </van-popup>
</template>

<script>

  export default {
    name: "LocationPopup",
    props: {
      latitude: {
        type: Number,
        default: 0
      },
      longitude: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        show: false,
        showError: false,
        mapObj: null,

        locationInfo: {
          latitude: 0,
          longitude: 0
        },
        locationAddr: '',
      }
    },
    created() {
      if (this.$refs.amap) {
        this.mapObj = this.$refs.amap.$$getInstance()
      }
    },

    methods: {
      open() {
        this.show = true

        this.locationInfo.latitude = this.latitude
        this.locationInfo.longitude = this.longitude

        setTimeout(() => {
          console.log('AMap', AMap)
          this.getLocation()
        }, 1000)

      },

      getLocation() {
        if (this.$refs.amap && this.$refs.amap.$$getInstance) {
          this.mapObj = this.$refs.amap.$$getInstance()
        }

        if (!this.mapObj) {
          return
        }
        this.mapObj.setCenter([this.locationInfo.longitude, this.locationInfo.latitude])

        this.getAddress(this.locationInfo.longitude, this.locationInfo.latitude, (addRes) => {
          this.locationAddr = addRes.regeocode.formattedAddress
        })

        const icon = new AMap.Icon({
          size: new AMap.Size(24, 40),    // 图标尺寸
          image: 'https://api.pro.surongyun.cn/fs/file/download/516371809210204161',
          imageSize: new AMap.Size(24, 40)   // 根据所设置的大小拉伸或压缩图片
        });

        const locationMarker = new AMap.Marker({
          position: new AMap.LngLat(this.locationInfo.longitude, this.locationInfo.latitude),
          icon: icon,
          offset: new AMap.Pixel(-26, -13),
          autoRotation: true,
          title: ''
        });
        this.mapObj.add(locationMarker);
        this.mapObj.setZoom(16)

        //地图加载失败
        this.mapObj.on("error", function () {
          alert("地图加载失败，请重新进入页面或刷新当前页面重试");
        });

      },

      getAddress(x, y, callback) {
        console.log('getAddress111', x, y)
        AMap.plugin(['AMap.Geocoder'], () => {
          let geocoder = new AMap.Geocoder({})
          // 109.07986,34.315921
          geocoder.getAddress([x, y], (status, result) => {
            if (status === 'complete' && result.regeocode) {
              // 处理返回结果
              if (callback) callback(result)
            } else {
              console.log('getAddress', status, result)
            }
          })
        })
      },

      location() {
        this.mapObj.setCenter([this.locationInfo.longitude, this.locationInfo.latitude])
        this.mapObj.setZoom(16)
      },
      cancel() {
        this.show = false
      },
      closePopup() {

        if (!this.mapObj) {
          return
        }
        this.mapObj.clearMap()
        this.$notify.clear()
      }
    }
  }
</script>

<style lang="less">

  .amap-logo,
  .amap-copyright {
    display: none !important;
  }

  .show-location-popup {

    .location-popup-container {
      height: 100%;
      position: relative;

      .map-container {
        height: 100%;
        width: 100%;
      }

      .location-addr {
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        height: auto;
        min-height: 40px;
        background-color: rgba(0,0,0,0.5);
        padding: 10px 20px;
        color: #fff;
        display: flex;
        align-items: center;
        font-size: 14px;
        line-height: 22px;
      }

      >.location-btn {
        position: absolute;
        top: 20px;
        left: 20px;
        width: 20px;
        height: 20px;
        font-size: 20px;
        background-color: #ffffff;
        color: #5e6d82;
        cursor: pointer;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .close-btn {
        position: absolute;
        top: 20px;
        right: 20px;
        width: 20px;
        height: 20px;
        font-size: 20px;
        background-color: #ffffff;
        color: #5e6d82;
        cursor: pointer;
        border-radius: 50%;
      }

    }

  }
</style>

